import {createContext, useContext} from 'react'
import type {Author} from '../types'

const CurrentUserContext = createContext<Author | undefined>(undefined)

export function CurrentUserProvider({user, children}: React.PropsWithChildren<{user?: Author}>) {
  return <CurrentUserContext value={user}> {children} </CurrentUserContext>
}

export function useCurrentUser() {
  return useContext(CurrentUserContext)
}

try{ CurrentUserContext.displayName ||= 'CurrentUserContext' } catch {}
try{ CurrentUserProvider.displayName ||= 'CurrentUserProvider' } catch {}